import { useLazyQuery, useMutation } from '@apollo/client';
import LibraryHeader from '../../components/LibraryHeader/LibraryHeader';
import MaterialsContainer from '../../components/MaterialsContainer/MaterialsConatiner';
import PDFViewer from '../../components/PDFViewer/PDFViewer';
import FileUpload from '../../components/Popups/FileUpload';
import './TeacherTeachingMaterial.scss';
import { useCallback, useEffect, useState } from 'react';
import { CONVERT_PPT_DOCS_TO_PDF, DELETE_EBOOK_MATERIAL, UPDATE_EBOOK_MATERIAL, UPLOAD_MATERIAL, VIEW_ALL_EBOOK_MATERIAL } from './api/TeacherTeachingMaterialQuery';
import ToasterWithMessage from '../../components/toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import { useAppSelector } from '../../redux/app/hooks';
import { materialsData } from '../../utils/interface';
import { STUDENT_ROLE } from '../../utils/constants';
import FileViewer from '../../components/FileViewer/FileViewer';
import CsvViewer from '../../components/CsvViewer/CsvViewer';
import EpubFileViewer from '../../components/EpubFileViewer/EpubFileViewer';
import { READ_CLASSROOMUPDATES } from '../TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import images from '../../assets/images';
import { getFileViewerType,getScreenDimensions } from '../../utils/helper';

const TeacherTeachingMaterial = () => {
    const { uploadCloud } = images;
    const [url, setUrl] = useState<string>();
    const [pdfFileData, setPdfFileData] = useState<materialsData | undefined>();
    const [filename, setFilename] = useState<string>();
    const [fileData, setFileData] = useState<File | null>();
    const [isUploadOpen, setIsUploadOpen] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const [openPdf, setOpenPdf] = useState(false);
    const [materialsData, setMaterialsData] = useState<[materialsData]>();
    const [searchValue, setSearchValue] = useState<string>('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFailed, setUploadFailed] = useState<boolean>(false);
    const [uploadFileName, setUploadFileName] = useState<string>('');
    const [materialAction,setMaterialAction] = useState<string>('');
    const [uploaded, setuploaded] = useState(false);
    const { success, error } = ToasterWithMessage();
    const { state } = useLocation();
    const selectedLibraryId = localStorage.getItem('selectedLId');
    const selectedSubjectId = localStorage.getItem('selectedSId');
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const role = useAppSelector((state) => state.auth.role);
    const backNavigation = role === STUDENT_ROLE ? '/student-classroom/ebooks/materials' : '/teacher-classroom/ebooks/materials';
    const navigate = useNavigate();
    const profile = useAppSelector((state) => state.auth.adminProfile);

    const [uploadTeachingMaterial] = useMutation(UPLOAD_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.insertMaterialIntoEbookMaterials) {
                setFileData(null);
                if (filename) {
                    setUploadFileName(filename);
                }
                setuploaded(true);
                setUploadProgress(100);
                setFilename('');
                setUrl('');
                getAllTeachingMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: "Materials",
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                });
            }
        },
        onError: (err) => {
            // error(err?.message);
            if (filename) {
                setUploadFileName(filename);
            }
            setuploaded(true);
            setUploadProgress(0);
            setUploadFailed(true);
        }
    });

    
    const [updateTeachingMaterial] = useMutation(UPDATE_EBOOK_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.updateEbookMaterials) {
                if(materialAction === "share"){
                    success("Shared successfully");
                }else if(materialAction === "undoShare"){
                    success("Unshared successfully");
                }
                getAllTeachingMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: "Materials",
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                });
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [deleteTeachingMaterial] = useMutation(DELETE_EBOOK_MATERIAL, {
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            if (data?.deleteEbookMaterials) {
                success("Deleted successfully");
                getAllTeachingMaterial({
                    variables: {
                        lId: selectedLibraryId,
                        sjId: selectedSubjectId,
                        type: "Materials",
                        cId: selectedClassRoomId,
                        limit: null,
                        offset: null,
                        searchInput: `%${searchValue.trim()}%`,
                        orderByColumn: null,
                        orderByDirection: null,
                        isclassroom: role === STUDENT_ROLE ? true : [true, false],
                    }
                });
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [getAllTeachingMaterial, { loading }] = useLazyQuery(VIEW_ALL_EBOOK_MATERIAL, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            if (data?.getMaterialsFromEbookType?.nodes) {
                setMaterialsData(data?.getMaterialsFromEbookType?.nodes);
            }
        },
        onError: (err) => {
            error(err?.message);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [convertPptDocToPdf, { loading: convertLoading }] = useLazyQuery(CONVERT_PPT_DOCS_TO_PDF, {
        fetchPolicy: 'network-only',
        onCompleted: (data) => {
            console.log('CONVERT_PPT_DOCS_TO_PDF response========>',data);
        },
        onError: (err) => {
            error(err?.message);
            // setuploaded(true);
            // setUploadProgress(0);
            // setUploadFailed(true);
            if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
                setTimeout(() => {
                    if (role === STUDENT_ROLE) {
                        navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
                    } else {
                        navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
                    }
                }, 2000);
            }
        }
    });

    const [readFeed] = useMutation(READ_CLASSROOMUPDATES, {
        fetchPolicy: 'network-only',
        onCompleted : (data) =>{
        },
        onError: (err) =>{
          console.log(err.message)
        }
      })
    
      useEffect(()=>{
    if(role === STUDENT_ROLE){
      if(materialsData && materialsData.length > 0){
        materialsData?.forEach((data) => {
          if (data.feedId) {
            readFeed({
              variables: {
                fId: data.feedId,
                uId: profile?.getCurrentUser?.nodes[0]?.uId
              }
            })
          }
        });
      }
    }
      },[materialsData, profile?.getCurrentUser?.nodes, readFeed, role])

    useEffect(() => {
        getAllTeachingMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                type: "Materials",
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: '%%',
                orderByColumn: null,
                orderByDirection: null,
                isclassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        })
    }, []);

    useEffect(() => {
        if (fileData && filename && filename !== '' && url) {
            console.log('url==========>', url);
            
            const parts = url.split('.');
            const extension = parts.length > 1 ? parts.pop() : undefined; // get the extension
    
            const commonUploadVariables = {
                filename: filename?.replace(/\.pdf$/, "")?.trim(),
                filepath: url,
                filesize: fileData?.size,
                isclassroom: false,
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                type: "Materials",
                cId: selectedClassRoomId,
                filetype: fileData?.type === "application/pdf" ? "pdf" : fileData?.type === "text/csv" ? "csv" : fileData?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? "xlsx" : fileData?.type === "application/vnd.ms-excel" ? "xls" : fileData?.type === "application/vnd.ms-powerpoint" ? "ppt" : fileData?.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation" ? "pptx" : fileData?.type === "application/epub+zip" ? "epub" : fileData?.type === "application/msword" ? "doc" : fileData?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ? "docx" : null
            };
    
            if (extension && ['doc', 'docx', 'ppt', 'pptx'].includes(extension.toLowerCase())) {
                // Convert documents or PowerPoint files to PDF
                convertPptDocToPdf({
                    variables: {
                        key: url
                    }
                }).catch(error => {
                    error(error);
                    console.error("Error during conversion or upload:", error);
                });
                uploadTeachingMaterial({
                    variables: commonUploadVariables,
                });
            } else {
                // Directly upload if no conversion is needed
                uploadTeachingMaterial({
                    variables: commonUploadVariables,
                });
            }
        }
    }, [fileData, filename, url]);

    const handleOpenFile = (pdfData: materialsData) => {
        setOpenPdf(true);
        setPdfFileData(pdfData);
    }

    //To close pdf detailed view
    const handleClosePdf = () => {
        setOpenPdf(false);
        setPdfFileData(undefined);
        getAllTeachingMaterial({
            variables: {
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                type: "Materials",
                cId: selectedClassRoomId,
                limit: null,
                offset: null,
                searchInput: `%${searchValue.trim()}%`,
                orderByColumn: null,
                orderByDirection: null,
                isclassroom: role === STUDENT_ROLE ? true : [true, false],
            }
        });
    }

    //To done actions in materials
    const handleMaterialActions = (data:materialsData,action:string) =>{
        if(action === "share"){
            setMaterialAction("share");
            updateTeachingMaterial({
                variables:{
                    isClassroom: true,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Materials",
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        }else if(action === "undoShare"){
            setMaterialAction("undoShare");
            updateTeachingMaterial({
                variables:{
                    isClassroom: false,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Materials",
                    cId: selectedClassRoomId,
                    fId: data?.fileId
                }
            });
        }else if(action === "delete"){
            setMaterialAction('');
            deleteTeachingMaterial({
                variables:{
                    cId: selectedClassRoomId,
                    fId: data?.fileId,
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Materials"
                }
            })
        }
    };

    const handleSearchDebounce = useCallback(
        debounce((value) => {
            setSearchValue(value);
            getAllTeachingMaterial({
                variables: {
                    lId: selectedLibraryId,
                    sjId: selectedSubjectId,
                    type: "Materials",
                    cId: selectedClassRoomId,
                    limit: null,
                    offset: null,
                    searchInput: `%${value.trim()}%`,
                    orderByColumn: null,
                    orderByDirection: null,
                    isclassroom: role === STUDENT_ROLE ? true : [true, false],
                }
            });
        }, 500),
        [getAllTeachingMaterial]
    );
    
    //To open upload popup
    const handleOpenUpload = () => {
        setIsUploadOpen(true);
        setOpen(true);
    };

    return (
        <div className="teacherTeachingMaterial">
            <LibraryHeader
                image={state?.imageSrc}
                backgroundColor={state?.backGroundColor}
                subject={state?.title}
                subCategory={role === STUDENT_ROLE ?'My Learning Materials' : 'My Teaching Materials'}
                setIsUploadOpen={setIsUploadOpen}
                openPdf={openPdf}
                onClose={handleClosePdf}
                setOpen={setOpen}
                backNavigation={{ path: backNavigation, state: state }}
                handleSearchDebounce={handleSearchDebounce}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
            />
            {
                openPdf ? (
                    pdfFileData?.filetype === "pdf" ? 
                      <PDFViewer file={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} pdfFileData={pdfFileData} onClose={handleClosePdf} type={"Teaching Material"} />
                    // : pdfFileData?.filetype === "csv" ? 
                    //     <div className='excelOuterContainer'>
                    //         <CsvViewer fileUrl={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} fileData={pdfFileData} onClose={handleClosePdf}/>
                    //     </div>
                    : (pdfFileData?.filetype === "doc" || pdfFileData?.filetype === "docx" || pdfFileData?.filetype === "ppt" || pdfFileData?.filetype === "pptx" || pdfFileData?.filetype === "xls" || pdfFileData?.filetype === "xlsx") ?
                      <div className='excelOuterContainer'>
                            <FileViewer fileUrl={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} fileData={pdfFileData} onClose={handleClosePdf} fileType={getFileViewerType(pdfFileData?.filetype)}/>
                      </div>
                    : (pdfFileData?.filetype === "csv") ? 
                    <div className='excelOuterContainer'>
                        <CsvViewer fileUrl={baseUrl + pdfFileData?.filepath} fileData={pdfFileData} onClose={handleClosePdf} />                       
                    </div>
                    : (pdfFileData?.filetype === "epub") ?
                        <div className='excelOuterContainer'>
                            <EpubFileViewer fileUrl={pdfFileData?.filepath ? baseUrl + pdfFileData?.filepath : ''} fileData={pdfFileData} />
                        </div>
                    : <></>
                    )
                    :
                    <>
                        <div className='teacherTeachingMaterialBody' style={{height: role=== STUDENT_ROLE ? '91%':''}}>
                            {
                                loading ? <Loader bottom='110px' />
                                    :
                                    <MaterialsContainer
                                        subject={state?.title}
                                        subCategory={`Ebooks/My Learning Materials`}
                                        materialsData={materialsData}
                                        handleOpenFile={handleOpenFile}
                                        handleMaterialActions={handleMaterialActions}
                                    />
                            }
                              {/* {role !== STUDENT_ROLE && <div className='libraryUploadButtonMobile' onClick={handleOpenUpload}>
                                <img src={uploadCloud} alt="upload" className='uploadImage' />
                            </div>} */}
                        </div>
                    </>
            }
            {isUploadOpen && <FileUpload type='teachingMaterials' name="Materials" setUrl={setUrl} open={open} setOpen={setOpen} setIsUploadOpen={setIsUploadOpen} folderName="materials" setFilename={setFilename} setFileData={setFileData} setUploadFailed={setUploadFailed} setUploadProgress={setUploadProgress} setuploaded={setuploaded} setUploadFileName={setUploadFileName}/>}
            {/* {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />} */}

            {uploaded && <UploadToaster uploaded={uploaded} setuploaded={setuploaded} uploadProgress={uploadProgress} setUploadProgress={setUploadProgress} fileName={uploadFileName} setUploadFileName={setUploadFileName} uploadFailed={uploadFailed} setUploadFailed={setUploadFailed} />}

            {(getScreenDimensions()?.isMobileScreen && role !== STUDENT_ROLE) && !openPdf &&
                <div className='libraryHeaderUploadContainer'> 
                    <div className='libraryHeaderUpload' onClick={handleOpenUpload}>
                        <img src={uploadCloud} alt="upload" className='uploadImage' />
                    </div>
                </div>}
        </div>
    )
}

export default TeacherTeachingMaterial;
